import React from "react";

import styled from "@mui/material/styles/styled";
import MuiTableRow, {
  TableRowProps as ITableRowProps,
} from "@mui/material/TableRow/TableRow";

const StyledTableRow = styled(MuiTableRow)(({ theme }) => ({
  ".MuiTableBody-root & .MuiTableCell-root": {
    ...theme.typography.bodySecondaryReg,
    height: "64px",
    padding: "16px",
    "&:not(:last-child)": {
      paddingRight: 0,
    },
  },
  "&:last-child": {
    ".MuiTableCell-body": {
      borderBottom: "none",
    },
  },
}));

const TableRow = React.forwardRef<HTMLTableRowElement, TableRowProps>(
  ({ children, sx, ...rowProps }, ref) => {
    return (
      <StyledTableRow
        sx={{ overflowX: "scroll", ...sx }}
        ref={ref}
        {...rowProps}
      >
        {children}
      </StyledTableRow>
    );
  }
);

TableRow.displayName = "TableRow";

export type TableRowProps = ITableRowProps;
export default TableRow;
